import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
    ClientParametersRequest,
    UpdateClientParametersRequest,
} from '../../types/ClientParameters';
import { mapUserConfigResponseToUserConfig } from '../../types/UserConfig';
import {
    requestClientParameters,
    requestUserConfig,
    updateClientParameter,
} from '../config/config';

export function useUserConfig(loggedIn: boolean = true) {
    return useQuery({
        queryKey: ['userConfig'],
        queryFn: async ({ signal }) => {
            const userConfigResponse = (await requestUserConfig(signal))?.data;
            if (userConfigResponse) return mapUserConfigResponseToUserConfig(userConfigResponse);
        },
        enabled: loggedIn,
    });
}

export function useRequestClientParameters(payload: ClientParametersRequest) {
    return useQuery({
        queryKey: ['clientParameters', ...payload.names],
        queryFn: async ({ signal }) => (await requestClientParameters(payload, signal)).data,
    });
}

export function useUpdateClientParameter() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data: UpdateClientParametersRequest) =>
            await updateClientParameter(data),
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: ['clientParameters'] });
            queryClient.invalidateQueries({ queryKey: ['userConfig'] });
        },
    });
}
